import { Box as u } from "@mui/material";
import { useConfigContext as d } from "../config/ConfigContext.js";
import { createStrictContext as l } from "../../util/context/createStrictContext.js";
import * as h from "ramda";
import { useCallback as c } from "react";
import { jsxs as f, jsx as g } from "react/jsx-runtime";
const [x, _] = l("Geetest4"), k = (i) => {
  var r;
  const {
    children: a
  } = i, {
    config: p
  } = d(), s = (r = p.geeTest) == null ? void 0 : r.id, n = c((t, o) => {
    t.appendTo("#captcha").onReady(() => {
      t.showCaptcha();
    }).onSuccess(() => {
      const e = t.getValidate();
      h.isNotNil(e) && o({
        captchaOutput: e.captcha_output,
        genTime: e.gen_time,
        lotNumber: e.lot_number,
        passToken: e.pass_token
      });
    });
  }, []), m = c((t) => {
    import("../../scripts/geetest4.raw.js").then(() => {
      window.initGeetest4({
        captchaId: s,
        language: "eng",
        product: "bind",
        protocol: "https://"
      }, (o) => {
        n(o, t);
      });
    });
  }, [s, n]);
  return /* @__PURE__ */ f(x, {
    value: {
      doGeetest: m
    },
    children: [/* @__PURE__ */ g(u, {
      className: "captcha"
    }), a]
  });
};
export {
  k as Geetest4Provider,
  _ as useGeetest4Context
};
//# sourceMappingURL=Geetest4Context.js.map
